import React from 'react';

// RFPC-1334: "No AI generated content" human-made callout shown in the search filter
// sidebar (all search pages, all users) when the `messaging_updates` experiment is in the
// `test` variant. Matches Figma node 863:17781. The mint palette uses the `green-ai`
// design-system colors (green-ai-100 / green-ai-900); the 18px line-height is inline since
// JIT is disabled.
const AI_STATEMENT_URL =
  'https://www.storyblocks.com/resources/news/storyblocks-ai-statement';

function HumanMadeCalloutBanner() {
  return (
    <div
      className="flex flex-col items-center gap-1 px-4 py-2 mt-2 mb-0 rounded-2xl text-xs bg-green-ai-100 text-green-ai-900"
      style={{ lineHeight: '18px' }}
      data-cy="humanMadeCalloutBanner"
    >
      <div className="w-full font-bold">No AI generated content</div>
      <p className="w-full m-0">
        No need to filter - we have a zero generative AI policy for our library
        content, so everything is human-made.{' '}
        <a
          className="underline text-green-ai-900"
          href={AI_STATEMENT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </a>
      </p>
    </div>
  );
}

export default HumanMadeCalloutBanner;
